exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".list-group{\r\n    margin: 0px;\r\n    height: auto;\r\n    cursor: pointer;\r\n}\r\n\r\n.list-group-item{\r\n    display: flex;\r\n    flex-direction: row;\r\n    background-color: transparent;\r\n    padding-bottom: 5px;\r\n    border: 0px;\r\n    text-align: left;\r\n}\r\n\r\n\r\n\r\n.item-titulo{\r\n    color: white;\r\n}\r\n\r\n.item-icono{\r\n    color: rgb(255, 255, 255);\r\n    padding-right: 10px;\r\n}\r\n\r\na .list-group-item{\r\n    border-radius: 0px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/sidebar/components/preferidos/item-preferidos/item-preferido.style.css
// module id = 639
// module chunks = 0